import styled from 'styled-components';

// Constants
import breakpoints from 'constants/breakpoints';

// Components
import { Button } from 'top-component-library';

export const Container = styled.div`
  max-width: 100%;
  width: 100%;
`;

export const TopLevelButton = styled(Button)`
  height: auto;
  background: var(--color-button-landing-page__regular);
  border-color: var(--color-button-landing-page__regular);
  border: none;
  border-radius: var(--button__border-radius);
  margin-bottom: 1rem;
  max-width: 100%;
  white-space: normal;
  width: 100%;

  &.ant-btn {
    padding: 0.75rem 3rem 0.75rem 3rem;
  }

  &:hover {
    background: var(--color-button-landing-page__regular);
  }

  &:focus {
    background: var(--color-button-landing-page__regular);
  }
`;

export const GroupButton = styled(Button)`
  display: flex;
  flex-basis: auto;
  flex-grow: 1;
  flex-shrink: 1;
  justify-content: center;
  align-items: center;
  height: auto;
  background: var(--color-button-landing-page__regular);
  border-color: var(--color-button-landing-page__regular);
  border: none;
  border-radius: var(--button__border-radius);
  white-space: normal;
  color: white;
  margin-bottom: 1rem;
  width: 100%;
  max-width: 100%;

  @media (min-width: ${breakpoints.sm}px) {
    width: calc(50% - 0.5rem);
    max-width: calc(50% - 0.5rem);
    margin-right: 1rem;

    &:nth-of-type(2) {
      margin-right: 0;
    }
  }

  @media (min-width: ${breakpoints.xl}px) {
    width: calc(33% - 0.6667rem);
    max-width: calc(33% - 0.6667rem);
    margin-right: 1rem;

    &:nth-of-type(2) {
      margin-right: 1rem;
    }

    &:nth-of-type(3) {
      margin-right: 0;
    }
  }

  &:last-child {
    margin-right: 0;
  }

  &.ant-btn {
    padding: 0.75rem 1rem;
  }

  &:hover {
    background: var(--color-button-landing-page__regular);
    border-color: var(--color-button-landing-page__regular);
    color: white;
  }

  &:active {
    background: var(--color-button-landing-page__dark);
    border-color: var(--color-button-landing-page__dark);
    color: white;
  }

  &:focus {
    background: var(--color-button-landing-page__regular);
    border-color: var(--color-button-landing-page__regular);
    color: white;
  }
`;

export const ButtonGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
